<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
	<div class="row">
	  <div class="col-12"></div>
	  <div class="col-12">
		<div class="card">
		  <div class="card-content">
			<div class="card-body">
			  <!-- ngx-datatable-filter -->
			  <fieldset class="form-group">
				<div class="row align-items-end mt-0 pagination-body">
				  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-2">
					<div class="btn-group enrollment-list-btn-info" role="group">
					  <!-- <button class="btn enrollment-list-buttons cursor-pointer" type="button"
						*ngFor="let status of statusList"
						[ngClass]="{'btn-primary':activeTab ==status?.id,'btn-outline-primary':activeTab!=status?.id}"
						(click)="activeCourseTab(status?.id)">{{status.name}}</button> -->
					</div>
				  </div>
				 
				  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
					<div class="row-flex">
						<div class="col-flex-2 mb-1">
							<label>Start Date</label>
							<input type="date" [(ngModel)]="startDate" class="form-control" (change)="getStartDate($event)">
						</div>
						<div class="col-flex-2 mb-1">
							<label>End Date</label>
							<input type="date" [(ngModel)]="endDate" class="form-control" (change)="getEndDate($event)">
						</div>
					  <!-- <div class="col-flex-2 mb-1 position-relative">
						<input id="ngx-filter-ref"
						  class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
						  type="text" placeholder="Search" #name [(ngModel)]="searchVal"
						  (keydown.enter)="getCourseFilter(searchVal)" />
						<button class="btn search-btn glow position-absolute" (click)="getCourseFilter(searchVal)">
						  <i class="ft-search text-white cursor-pointer"></i>
						</button>
					  </div>
					  <div class="col-flex-2 mb-1">
						<button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
						  Reset
						  <i class="ft-filter text-white cursor-pointer"></i>
						</button>
					  </div>
					  <div class="col-flex-2 mb-1">
						<button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
						  routerLink="/course/course-add-edit" placement="top" ngbTooltip="Add New">
						  +
						</button>
					  </div> -->
					</div>
				  </div>
				  <!-- <div class="col-12">
					<button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Course Guideline</button>
					</div> -->
				</div>
				<!-- <div>
				  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
				  [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
				  [count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>
				</div> -->
			  </fieldset>
			  <div>
				<div *ngFor="let item of rows.items">
					<h5>{{item.month}} {{item.year}} - Total Enrollments : {{item.totalCount}}</h5>
				  <div class="main_heading cursor-pointer" (click)="collapse.toggle()" [attr.aria-expanded]="courseTypeView[i]"
					aria-controls="collapseExample" *ngFor="let course of item.courses">
					<h5 class="bg-light-info">
					  {{course?.courseName}} ({{course?.count}})</h5>
				  <ngx-datatable id="demo" #collapse="ngbCollapse" [(ngbCollapse)]="!courseTypeView[i]" class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
				  [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="course.enrollments" [scrollbarH]="true"
				  [columns]="columns" [externalPaging]="true" [count]="course?.count" [offset]="page.offset"
				  >
				  <ngx-datatable-column name="Name" prop="name">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					  <div class="d-flex align-items-center">
						
						<div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
						  <div class="avatar-content">
							{{ row?.name | shortName }}
						  </div>
						</div>
						<div class="cell-line-height">
                        <p class="font-medium-1 line-height-1 mb-0">
                          {{ row.name }}
                        </p>
						</div>
						
					  </div>
					</ng-template>
				  </ngx-datatable-column>
				  <ngx-datatable-column name="Email" prop="email">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						{{row?.email}}
					</ng-template>
				  </ngx-datatable-column>
				  <ngx-datatable-column name="Phone" prop="phone">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						{{row?.phone}}
					</ng-template>
				  </ngx-datatable-column>
				 
				  <!-- <ngx-datatable-column name="Actions"
					*ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
					<ng-template let-row="row" ngx-datatable-cell-template>
					  <i *ngIf="user_role.roles ==='admin' || empType.includes('Management') || empType.includes('Training Moderator') || user_role.name ==='Kamlesh Yadav' " class="ft-more-vertical text-primary cursor-pointer mx-1" mat-button [matMenuTriggerFor]="menu"></i>
					  <mat-menu #menu="matMenu" id="menu">
						<button mat-menu-item *ngIf="user_role.roles ==='admin' || empType.includes('Management') || empType.includes('Training Moderator') || user_role.name ==='Kamlesh Yadav'" (click)="confirmUpdate(row._id,'edit course')">
						 
						Edit
						
						<button mat-menu-item *ngIf="user_role.roles ==='admin'" [routerLink]="['/course/course-manage', row._id]">
						
						  Reports
						</button>
						<button mat-menu-item (click)="confirmUpdate(row._id,'view lms')">
						
						  View Lms
						</button>
						<button mat-menu-item (click)="confirmUpdate(row._id,'student lms')">
						 
						  View Student Lms
						</button>
						<button mat-menu-item *ngIf="empType.includes('Management') || empType.includes('Training Moderator') || user_role.roles =='admin'" [routerLink]="['/course/course-manage', row._id]">
						  Course Manage
						</button>
					  </mat-menu>
						
						
						 <i class="ft-settings text-primary cursor-pointer mx-1" mat-button [matMenuTriggerFor]="menu2"></i>
						 <mat-menu #menu2="matMenu" id="menu2">
						  <button mat-menu-item (click)="copyCourseLinkMeanderTraining(row?._id)">
							
							Meander Training URL
						  </button>
						  <button mat-menu-item (click)="copyCourseLinkMeanderSoftware(row?._id)">
							
							Meander Software Url
						  </button>
						 </mat-menu>
						
					</ng-template>
				  </ngx-datatable-column> -->
				</ngx-datatable>
				</div>
				</div>
			  </div>
			 
			  <!-- ngx-datatable-filter -->
			</div>
		  </div>
		</div>
	  </div>
	</div>
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div>